// ============================================================
// A CHARACTER'S OWN SOLO MODES ON THE DRUM (plan modes-rework; "stances"
// before it).
//
// The catalog is the same for everybody; these plates are the acting
// character's own: one per Solo mode, appended after the catalog under one
// caption. Pressing one switches it (`execution: 'ownStance'`), exactly as
// its plate on the actor's panel does. Always on has no plate: nobody
// switches it.
//
// APPENDED, never interleaved: a plate's place on the cylinder is its
// index, and E2E navigates by it - the catalog's own plates must not move
// because somebody has stances.
//
// Pure. Zero React dependency.
// ============================================================
import { effectSentence } from '../character/effectItems';
import type { SoloMode } from '../character/soloModes';
import type { ActionDef } from './types';

/** What a stance plate's id starts with: no catalog row can share it (ids there have no colon). */
export const STANCE_PLATE_PREFIX = 'own:';

/** The plates for these Solo modes (as stored on a sheet). */
export function stancePlates(modes: readonly SoloMode[] | undefined): ActionDef[] {
  return (modes ?? []).map((mode): ActionDef => ({
    id: `${STANCE_PLATE_PREFIX}${mode.id}`,
    name: mode.name,
    cost: 'free',
    category: 'stance',
    execution: 'ownStance',
    section: 'own',
    stanceId: mode.id,
    requiresActor: true,
    blurb: `${mode.group?.name ?? 'Solo mode'}. ${mode.effects.map(effectSentence).join(', ') || 'No effects yet'}`,
  }));
}

/** The drum's plates for this character: the catalog, then their own. The catalog itself when they have none. */
export function withStancePlates(catalog: ActionDef[], modes: readonly SoloMode[] | undefined): ActionDef[] {
  const own = stancePlates(modes);
  return own.length > 0 ? [...catalog, ...own] : catalog;
}
